import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from "../context/LanguageContext";

// --- SVG ICONS ---
const Icons = {
  Home: () => (
    <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
  Lock: () => (
    <svg className="w-32 h-32 text-indigo-200 mx-auto mb-6 animate-pulse-slow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 14V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
};

const Unauthorized = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4 relative overflow-hidden">
      
      {/* --- DECORATIVE BACKGROUND --- */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-indigo-200/30 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-rose-200/30 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute top-0 left-1/2 w-[80%] h-[1px] bg-gradient-to-r from-transparent via-indigo-200 to-transparent opacity-30" />

      {/* --- CONTENT CARD --- */}
      <div className="max-w-lg w-full text-center relative z-10 animate-fade-in-up">
        
        {/* Illustration Cadenas */}
        <Icons.Lock />
        
        {/* Code 403 avec Gradient (Légèrement différent : Rose/Indigo pour signaler l'interdiction) */}
        <h1 className="text-9xl font-black text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-indigo-600 tracking-tighter drop-shadow-sm select-none">
          403
        </h1>
        
        {/* Titre */}
        <h2 className="text-3xl font-bold text-gray-800 mt-4 mb-3">
          {t.accessDenied || "Access Denied"}
        </h2>
        
        {/* Description */}
        <p className="text-gray-500 mb-10 text-lg leading-relaxed px-4">
          {t.accessDeniedDesc || "Sorry, you don't have the necessary permissions to view this page."}
        </p>
        
        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="flex items-center justify-center bg-indigo-600 text-white px-8 py-3 rounded-xl font-semibold hover:bg-indigo-700 transition duration-300 shadow-lg shadow-indigo-200 w-full sm:w-auto transform hover:-translate-y-1"
          >
            <Icons.Home />
            {t.backHome || "Go Home"}
          </Link>
        </div>
      </div>

      <style jsx>{`
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(0.98); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s ease-out forwards;
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default Unauthorized;